export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_01.2f4f6264.png";